import {Componente} from "../../components/form-builder/model/form-builder.model";

export enum TipoChiusuraEnum {
  RESET = 'RESET'
}

export interface ConfigurazioneFrontEnd {
  placeholders: Record<string, string>;
  intestazione?: Array<string>;
  oggetto?: Array<string>;
  componenti: Array<Componente>;
  modaleChiusura?: ModaleChiusura;
  firma?: {
    descrizione?: string,
    firmatario?: Array<string[]>
  };
  [key: string]: any;
}

export interface ModaleChiusura {
  titolo?: string;
  descrizione?: string;
  buttonConferma?: string;
  buttonChiusura?: string;
  tipo?: TipoChiusuraEnum;
  reset?: Reset[];
}

export interface Reset {
  resetAll?: boolean;
  keyFormData?: string;
  keyFormGroup?: string;
  resetFormArrayOrGroup?: boolean;
  differentValueFormData?: any;
}

export interface ConfigurazionePratica {
  recaptchaAbilitato?: boolean;
  tipoConfermaPratica?: string;
  isReviewPdfEnabled?: boolean;
  isDomandaPerCittadinoUnica?: boolean;
  isDomandaCittadinoRipetibile?: boolean;
  [key: string]: any;
}
